import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4 pr-4" }
const _hoisted_2 = { class: "line-clamp-2" }

import { ref, onMounted } from "vue";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";
import type { Toast } from "@/SharedToastApp/types/toast.type";
import type { ToastMessengerData } from "@/shared/types/messenger.type";

const TOAST_DURATION = 4000;
const TOAST_LEAVE_DURATION = 360;

export default /*@__PURE__*/_defineComponent({
  __name: 'SharedToast',
  setup(__props) {

const _createUuid = () => (Math.random() + 1).toString(36).substring(2);
const _icons = new Map([
	["default", "checkmark-circled"],
	["info", "info"],
	["wishlist", "heart-filled"],
]);

let _toast: Toast | null = null;
const toast = ref<Toast>();

const _addToast = async ({ data }: ToastMessengerData) => {
	_toast = {
		id: _createUuid(),
		...data,
		icon: _icons.get(data.type ?? "default") as string,
	};

	// remove existing toast
	if (toast.value) {
		toast.value = undefined;
		await new Promise((resolve) => setTimeout(resolve, TOAST_LEAVE_DURATION));
	}

	toast.value = _toast;
	const id = _toast.id;
	setTimeout(() => {
		if (_toast?.id !== id) return;
		_removeToast();
	}, TOAST_DURATION);
};

const _removeToast = () => {
	_toast = null;
	toast.value = undefined;
};

onMounted(() => {
	OcmMessenger.subscribe(messengerPublicationTypes.ADD_TOAST, _addToast);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#shared-toast-container" }, [
    _createVNode(_Transition, { name: "shared-toast" }, {
      default: _withCtx(() => [
        (toast.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "shared-toast ocm-body1 grid max-w-96 grid-cols-[4rem,1fr] gap-x-1 justify-self-center rounded-lg bg-gray-beton",
              style: _normalizeStyle({ '--toast-leave-duration': TOAST_LEAVE_DURATION })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["grid items-center rounded-l-lg pl-3", toast.value.type === 'info' ? 'diagonal-info' : 'diagonal-success'])
              }, [
                _createVNode(SvgIcon, {
                  class: _normalizeClass(toast.value.type === 'wishlist' ? 'size-5' : 'size-4.5'),
                  "icon-name": toast.value.icon
                }, null, 8, ["class", "icon-name"])
              ], 2),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(toast.value.message), 1)
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})